import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import {
  user,
  useGetSeasonalThemeListDataQuery,
  useUpdateSeasonalThemeHeadDataMutation,
  useUpdateSeasonalThemeStatusMutation,
} from "../../../store/queries/User";
import { deleteSeasonalTheme } from "./api";
import { toast } from "react-toastify";
import { current } from "@reduxjs/toolkit";
import {
  getSeasonalThemeEditData,
  updateConfig,
} from "../../../store/slices/User/SeasonalTheme/seasonalThemeSlice";
import { IconText } from "@wac-ui-dashboard/wac_component_library";

const useSeasonalTheme = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageData, setImageData] = useState("");
  const [deletable, setDeletable] = useState(false);
  const dispatch = useDispatch();
  const seasonalThemeState = useSelector((state) => state.seasonalTheme);
  const { selectedId } = useSelector((state) => state.seasonalTheme);
  const { showEditModal } = useSelector((state) => state.global);
  const {
    data: seasonalThemeList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetSeasonalThemeListDataQuery({
    page_size: seasonalThemeState?.currentPageSize,
    page: seasonalThemeState?.currentPage,
    sort: seasonalThemeState?.sortBy,
    sort_order: seasonalThemeState?.sortOrder,
    search: seasonalThemeState?.search,
  });
  const [updateSeasonalThemeFields] = useUpdateSeasonalThemeHeadDataMutation();
  const [updateSeasonalThemeStatus] = useUpdateSeasonalThemeStatusMutation();
  const handleCreateClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = !state.showCreateModal;
        state.imagePreview = "";
        state.imageName = "";
        state.arabicImagePreview = "";
        state.arabicImageName = "";
        state.isEdit = false;
        state.editSeasonalThemeData = {};
        state.recapImagePreview = "";
        state.recapImageName = "";
        state.arabicRecapImagePreview = "";
        state.arabicRecapImageName = "";
      })
    );
  };
  useEffect(() => {
    if (seasonalThemeState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [seasonalThemeState.clearSelection]);

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };
  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

   const handleViewImage = (data) => {
    setShowImageModal(() => true);
    setImageData(data);
  };

  const handleToggle = (e, data) => {
    const newStatus = data.status === 1 ? 2 : 1;
    let body = {
      search_id: data?.id,
      status: newStatus,
    };
    updateSeasonalThemeStatus(body).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          user.util.updateQueryData(
            "getSeasonalThemeListData",
            {
              page_size: seasonalThemeState?.currentPageSize,
              page: seasonalThemeState?.currentPage,
              sort: seasonalThemeState?.sortBy,
              sort_order: seasonalThemeState?.sortOrder,
              search: seasonalThemeState?.search,
            },
            (cacheEntry) => {
              let currentCache = { ...current(cacheEntry) };
              const newResult = currentCache.data.result?.map((res) =>
                res.id === data?.id
                  ? {
                      ...res,
                      status: newStatus,
                    }
                  : res
              );
              currentCache = {
                ...currentCache,
                data: {
                  ...currentCache.data,
                  result: newResult,
                },
              };
              return currentCache;
            }
          )
        );
      } else if (
        response?.data?.status_code === 422 &&
        response?.data?.errors
      ) {
        const firstErrorKey = Object.keys(response?.data?.errors)[0];
        const firstErrorMessage = response?.data?.errors[firstErrorKey];
        toast.error(firstErrorMessage??`Something went wrong!`);
      } else {
        toast.error(`Something went wrong!`);
      }
    });
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
       image: (field, data) => {
              return (
                <div className="no-wrap">
                  <IconText
                    icon={
                      <span className="material-symbols-outlined x4">imagesmode</span>
                    }
                    title={`${"View Photo"}`}
                    onClick={() => handleViewImage(data?.image)}
                  />
                </div>
              );
            },
            alias_image: (field, data) => {
              return (
                <div className="no-wrap">
                  <IconText
                    icon={
                      <span className="material-symbols-outlined x4">imagesmode</span>
                    }
                    title={`${"View Photo"}`}
                    onClick={() => handleViewImage(data?.alias_image)}
                  />
                </div>
              );
            },
      status: (field, data) => {
        const isChecked = data?.status === 1;
        return (
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={isChecked}
              onChange={(e) => handleToggle(e, data)}
            />
          </div>
        );
      },
       theme_color: (field, data) => (
      <div className="d-flex align-items-center color_code">
        <span
          style={{
            display: "inline-block",
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: data?.theme_color,
            border: "1px solid #ccc",
          }}
        />
        <span>{data?.theme_color}</span>
      </div>
    ),

    text_color: (field, data) => (
      <div className="d-flex align-items-center color_code">
        <span
          style={{
            display: "inline-block",
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: data?.text_color,
            border: "1px solid #ccc",
          }}
        />
        <span>{data?.text_color}</span>
      </div>
    ),

    menu_color: (field, data) => (
      <div className="d-flex align-items-center color_code">
        <span
          style={{
            display: "inline-block",
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: data?.menu_color,
            border: "1px solid #ccc",
          }}
        />
        <span>{data?.menu_color}</span>
      </div>
    ),
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handleSort = (label) => {
    if (seasonalThemeState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder = seasonalThemeState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedId = e?.[0];
      })
    );
  };

  const handleDelete = async () => {
    const response = await deleteSeasonalTheme(selectedId);
    if (response && response.status === 200) {
      toast.success(`Deleted successfully.`);
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.search="";
        })
      );
      setTimeout(() => {
        refetch();
      }, 0);
    } else {
      toast.error(`Something went wrong !`);
    }
    handleDeleteModal();
    dispatch(
      updateConfig((state) => {
        state.clearSelection = true;
      })
    );
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };
  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };

   const closeImageModal = () => {
    setShowImageModal(() => false);
    setImageData("");
  };
 
  const handleEditAction = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showCreateModal = true;
        state.selectedId = e?.[0];
        state.isEdit = true;
      })
    );
    dispatch(getSeasonalThemeEditData(e?.[0]));
  };

  const handleSelection = (item) => {
    const selectedID = item?.[0];
    const selectedData = seasonalThemeList?.data?.result?.find(
      (res) => res?.id?.toString() === selectedID?.toString()
    );
    const deletable = selectedData && selectedData?.theme_type !== "Default";

    setDeletable(deletable);
  };
  return {
    isLoading,
    isFetching,
    seasonalThemeList,
    showEditModal,
    seasonalThemeState,
    paginationOptions,
    handleEditColumnsClick,
    updateSeasonalThemeFields,
    handleDeleteModal,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    handleDelete,
    refetch,
    getRow,
    deletable,
    imageData,
    showImageModal,
    closeImageModal,
    handleSelection,
  };
};

export default useSeasonalTheme;
